import * as yup from 'yup';
import { error } from '../text';

const numberTrim = (
  value: string | number | null | undefined,
  originalValue: string | number | null | undefined,
): number | null => {
  if (typeof originalValue === 'string') {
    return originalValue.trim() === '' ? null : Number(value);
  }
  if (value == null) {
    return null;
  }
  return Number(value);
};

const requiredStringValidation = yup.string().required(error.required).max(250, error.below250);
const nullableStringValidation = yup.string().nullable().max(250, error.below250);
const stringValidation = yup.string().nullable();
const dateValidation = yup.date().nullable().typeError(error.date);
const nullableNumberValidation = yup
  .number()
  .transform((value, originalValue) => numberTrim(value, originalValue))
  .typeError(error.number)
  .nullable();

export const aiOcrResultMainInfoSchema = yup.object().shape({
  mansionName: requiredStringValidation,
  propertyAddress: requiredStringValidation,
  roomNumber: requiredStringValidation,
  previousOwnerCorporateName: nullableStringValidation,
  establishmentDate: dateValidation,
  debtorAddress: nullableStringValidation,
  debtorName: nullableStringValidation,
  mortgageeCompanyName: nullableStringValidation,
  loanAmount: nullableNumberValidation,
  interestRate: nullableNumberValidation,
  candidateCompaniesByGemini: stringValidation,
  candidateCompanies: stringValidation,
});
